import { useContext } from "react";
import FilterSection from "./FilterSection";
import styled from "styled-components";
import { ProductContext } from "../../context/ProductContext";
import { useTranslation } from "react-i18next";
import ToggleSwitch from "../animations/ToggleSwitch";

const FilterContainer = styled.div`
  padding: 0 var(--spacing-md);
`;

const StockRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-md) 0;
  color: var(--text-100);
  font-size: var(--font-size-base);
`;

const FilterData = ({
  nicotineRanges,
  selectedCategories,
  selectedFormats,
  selectedNicotineRanges,
  filterOutOfStock,
  onCategoryChange,
  onFormatChange,
  onNicotineRangeChange,
  onFilterOutOfStock,
}) => {
  const { t } = useTranslation();
  const { category, products } = useContext(ProductContext);

  const groupedCategories = Array.from(
    new Set(products.map((product) => product.category_name).filter(Boolean))
  );
  const groupedFormats = Array.from(
    new Set(products.map((product) => product.format).filter(Boolean))
  );
  const nicotineLabels = nicotineRanges.map((range) => range.label);

  const countProductsInCategory = (categoryName) =>
    products.filter((product) => product.category_name === categoryName)
      .length;

  const countProductsInFormat = (format) =>
    products.filter((product) => product.format === format).length;

  const countProductsInNicotineRange = (label) => {
    const range = nicotineRanges.find((r) => r.label === label);
    if (!range) return 0;
    const [min, max] = range.range;
    return products.filter(
      (product) => product.nicotine >= min && product.nicotine <= max
    ).length;
  };

  return (
    <FilterContainer>
      {!category && (
        <FilterSection
          title={t("FILTER.BRAND")}
          options={groupedCategories}
          selectedValues={selectedCategories}
          onToggle={onCategoryChange}
          getCount={countProductsInCategory}
        />
      )}
      <FilterSection
        title={t("FILTER.FORMAT")}
        options={groupedFormats}
        selectedValues={selectedFormats}
        onToggle={onFormatChange}
        getCount={countProductsInFormat}
      />
      <FilterSection
        title={t("FILTER.STRENGTH")}
        options={nicotineLabels}
        selectedValues={selectedNicotineRanges}
        onToggle={(label) =>
          onNicotineRangeChange(nicotineRanges.find((r) => r.label === label))
        }
        getCount={countProductsInNicotineRange}
      />

      <StockRow>
        {t("FILTER.HIDE_OUT_OF_STOCK")}
        <ToggleSwitch
          onChange={onFilterOutOfStock}
          ariaLabel={t("FILTER.HIDE_OUT_OF_STOCK")}
          defaultChecked={filterOutOfStock}
        />
      </StockRow>
    </FilterContainer>
  );
};

export default FilterData;
